import { atomWithStorage } from "jotai/utils";

export const localeAtom = atomWithStorage<"fi" | "en">(
  "localeAtom",
  "fi",
  undefined,
  { getOnInit: true }
);
